import { useState, type FormEvent } from "react";
import { dueInfo } from "./format";
import { useUpdateTask } from "./hooks";
import type { Task } from "./types";

/** Pole daty terminu do formularzy dodawania zadań. */
export function DueInput({
  value,
  onChange,
}: {
  value: string;
  onChange: (value: string) => void;
}) {
  return (
    <label className="capture__due">
      <span>Termin</span>
      <input type="date" value={value} onChange={(e) => onChange(e.target.value)} />
    </label>
  );
}

const CLOSED = new Set<Task["status"]>(["done", "trashed"]);

/** Termin przy zadaniu na liście: etykieta, a po kliknięciu ustawianie i usuwanie. */
export function DueTag({ task }: { task: Task }) {
  const update = useUpdateTask();
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState("");
  const closed = CLOSED.has(task.status);
  const info = task.due_date ? dueInfo(task.due_date) : null;

  if (closed) return info ? <span>{info.plainLabel}</span> : null;

  function save(due_date: string | null) {
    update.mutate({ id: task.id, input: { due_date } }, { onSuccess: () => setEditing(false) });
  }

  function onSubmit(event: FormEvent) {
    event.preventDefault();
    save(draft || null);
  }

  function open() {
    setDraft(task.due_date ?? "");
    setEditing(true);
  }

  return (
    <>
      <button
        type="button"
        className={`due-tag ${info ? `due-tag--${info.tone}` : "due-tag--empty"}`}
        aria-expanded={editing}
        aria-label={info ? `Zmień termin: ${info.label}` : `Ustaw termin: ${task.title}`}
        onClick={() => (editing ? setEditing(false) : open())}
      >
        {info ? info.label : "+ termin"}
      </button>
      {editing && (
        <form className="due-edit" onSubmit={onSubmit}>
          <input
            type="date"
            className="due-edit__input"
            value={draft}
            aria-label="Termin"
            onChange={(e) => setDraft(e.target.value)}
          />
          <button className="btn btn--small btn--primary" type="submit" disabled={update.isPending}>
            Zapisz
          </button>
          {task.due_date && (
            <button
              className="btn btn--small"
              type="button"
              disabled={update.isPending}
              onClick={() => save(null)}
            >
              Usuń
            </button>
          )}
        </form>
      )}
    </>
  );
}
